import { apiGet } from "../ApiMethod";

export const acessTokenCallback = async () => {
  const response = await apiGet("_accessToken");
  return { ...response };
};